import type { Card, Game, GameDoc } from "@/store/types";

type GameDocLike = Omit<GameDoc, "cards" | "lastDrawn"> & {
  cards?: Card[];
  lastDrawn?: number;
};

export const gameDocToGame = (game: GameDocLike): Game => ({
  slug: game.slug,
  cards: game.cards,
  courts: game.courts,
  players: game.players,
  lastDrawn: game.lastDrawn ?? -1,
  perCourt: game.perCourt,
  roundId: game.roundId,
  shortCourt: game.shortCourt,
  updatedAt: game.updatedAt,
  syncStatus: "synced",
});

export const gameToCreateInput = (game: Game) => ({
  cards: game.cards,
  courts: game.courts,
  players: game.players,
  lastDrawn: game.lastDrawn,
  perCourt: game.perCourt,
  shortCourt: game.shortCourt,
});

export const gameToConfigInput = (game: Game) => ({
  ...gameToCreateInput(game),
  slug: game.slug ?? "",
  updatedAt: game.updatedAt,
});
